import React from 'react'
import Santosh from '../images/santosh.jpg'
import San from '../images/santo.jpg'
import '../App.css'

const About = () => {
  return (
    <>
    
   <div className="container flex flex-col space-y-24 md:flex-row mx-auto
    md:pb-8 lg:px-8  xl:p-8 md:space-x-20 lg:space-x-48 xl:space-x-56 ">
   
   
   
   <div className="lauda ml-4 w-10/12 md:w-full md:h-fit  xl:max-h-[32rem] p-2  mt-2 lg:mt-14
    xl:mt-2 transform md:hover:translate-x-5  bg-gray-800  md:pr-8 md:ml-8 rounded-[160%]">
   <img src={San} alt=""  className='w-fit h-10/12 lg:-translate-y-0.2 max-h-8/12 sm:w-full  sm:max-h-full lg:translate-x-12  xl:translate-y-12  md:object-contain rounded-xl'/>
   </div>
   
   <div className="about overflow-hidden sm:block 
   sm:h-1/4 pt-12 sm:p-0 sm:text-left -mt-20 lg:-mt-10 xl:pt-10 md:h-full lg:pr-12 xl:pr-28
    -translate-y-16 transform md:hover:translate-y-8  font-kalam">
    <h1 className='text-center md:font-bold text-4xl lg:text-3xl xl:text-5xl pb-8' > About Me</h1>
    <hr className='w-40 sm:w-40 mx-auto md:w-80  pb-0.5 mb-6 bg-slate-400' />
    <div className="mx-auto text-center block
    md:p-2  xl:p-12  md:font-italic md:font-semibold xl:text-2xl">
    <p className='mb-6 xl:text-2xl'>I'm Santosh. A Software Engineering Graduate &
     Tech enthusiast in love with the concept of solving the problem with the technology. I am always keen on learning new technology implementing it to solve our real world problems. 
    </p>
  
    <p className='xl:text-2xl'>When I'm not coding, you can find me out  hiking or cycling.</p>
    </div>
   </div>
   
   </div>
   
   
    </>
  )
}

export default About